export const GET_PROJECT_REQUEST = 'GET_PROJECT_REQUEST';
export const GET_PROJECT_SUCCESS = 'GET_PROJECT_SUCCESS';
export const GET_PROJECT_ERROR = 'GET_PROJECT_ERROR';
export const SELECT_PROJECT = 'SELECT_PROJECT';

export const GET_PURGE_PROJECTS_REQUEST = 'GET_PURGE_PROJECTS_REQUEST';
export const GET_PURGE_PROJECT_SUCCESS = 'GET_PURGE_PROJECT_SUCCESS';
export const GET_PURGE_PROJECT_ERROR = 'GET_PURGE_PROJECT_ERROR';
export const PURGE_PROJECT_REQUEST = 'PURGE_PROJECT_REQUEST';
export const PURGE_PROJECT_SUCCESS = 'PURGE_PROJECT_SUCCESS';
export const PURGE_PROJECT_ERROR = 'PURGE_PROJECT_ERROR';
export const CLOSE_PURGE_MODAL = 'CLOSE_PURGE_MODAL';
export const PURGE_ACTIONS = 'PURGE_ACTIONS';

export const EXPORT_PROJECT_REQUEST = 'EXPORT_PROJECT_REQUEST';
export const EXPORT_PROJECT_SUCCESS = 'EXPORT_PROJECT_SUCCESS';
export const EXPORT_PROJECT_ERROR = 'EXPORT_PROJECT_ERROR';
export const CANCEL_EXPORT_PROJECT = 'CANCEL_EXPORT_PROJECT';

export const GET_GENERAL_PROJECT_SETTINGS_REQUEST =
  'GET_GENERAL_PROJECT_SETTINGS_REQUEST';
export const GET_GENERAL_PROJECT_SETTINGS_SUCCESS =
  'GET_GENERAL_PROJECT_SETTINGS_SUCCESS';
export const GET_GENERAL_PROJECT_SETTINGS_ERROR =
  'GET_GENERAL_PROJECT_SETTINGS_ERROR';

export const UPDATE_PROJECT_NAME_REQUEST = 'UPDATE_PROJECT_NAME_REQUEST';
export const UPDATE_PROJECT_NAME_SUCCESS = 'UPDATE_PROJECT_NAME_SUCCESS';
export const UPDATE_PROJECT_NAME_ERROR = 'UPDATE_PROJECT_NAME_ERROR';

export const CREATE_PROJECT_SNAPSHOT_REQUEST =
  'CREATE_PROJECT_SNAPSHOT_REQUEST';
export const CREATE_PROJECT_SNAPSHOT_SUCCESS =
  'CREATE_PROJECT_SNAPSHOT_SUCCESS';
export const CREATE_PROJECT_SNAPSHOT_ERROR = 'CREATE_PROJECT_SNAPSHOT_ERROR';

export const GET_PROJECT_SNAPSHOTS_REQUEST = 'GET_PROJECT_SNAPSHOTS_REQUEST';
export const GET_PROJECT_SNAPSHOTS_SUCCESS = 'GET_PROJECT_SNAPSHOTS_SUCCESS';
export const GET_PROJECT_SNAPSHOTS_ERROR = 'GET_PROJECT_SNAPSHOTS_ERROR';

export const DOWNLOAD_PROJECT_SNAPSHOTS_REQUEST =
  'DOWNLOAD_PROJECT_SNAPSHOTS_REQUEST';
export const DOWNLOAD_PROJECT_SNAPSHOTS_SUCCESS =
  'DOWNLOAD_PROJECT_SNAPSHOTS_SUCCESS';
export const DOWNLOAD_PROJECT_SNAPSHOTS_ERROR =
  'DOWNLOAD_PROJECT_SNAPSHOTS_ERROR';

export const ROLLBACK_PROJECT_REQUEST = 'ROLLBACK_PROJECT_REQUEST';
export const ROLLBACK_PROJECT_SUCCESS = 'ROLLBACK_PROJECT_SUCCESS';
export const ROLLBACK_PROJECT_ERROR = 'ROLLBACK_PROJECT_ERROR';
export const ROLLBACK_PROJECT = 'ROLLBACK_PROJECT';

export const DELETE_PROJECT_REQUEST = 'DELETE_PROJECT_REQUEST';
export const DELETE_PROJECT_SUCCESS = 'DELETE_PROJECT_SUCCESS';
export const DELETE_PROJECT_ERROR = 'DELETE_PROJECT_ERROR';

export const INITIALIZE_VERSION_CONTROL_REQUEST =
  'INITIALIZE_VERSION_CONTROL_REQUEST';
export const INITIALIZE_VERSION_CONTROL_SUCCESS =
  'INITIALIZE_VERSION_CONTROL_SUCCESS';
export const INITIALIZE_VERSION_CONTROL_ERROR =
  'INITIALIZE_VERSION_CONTROL_ERROR';
export const RESET_PROJECT_BRANCH = 'RESET_PROJECT_BRANCH';

export const UPDATE_PROJECT_BRANCH = 'UPDATE_PROJECT_BRANCH';
